import type { UseMutationOptions } from "@tanstack/react-query";
import { apiRequest, type ApiError, useApiMutation } from "@/shared/api";

export type EmailOtpResponse = {
  status?: string;
};

export type SendEmailOtpPayload = {
  email: string;
};

export type VerifyEmailOtpPayload = {
  email: string;
  otp: string;
};

const sendEmailOtpRequest = (payload: SendEmailOtpPayload) => ({
  url: "/auth/otp/email/send",
  method: "post" as const,
  data: payload,
});

const verifyEmailOtpRequest = (payload: VerifyEmailOtpPayload) => ({
  url: "/auth/otp/email/verify",
  method: "post" as const,
  data: payload,
});

export const sendEmailOtp = (payload: SendEmailOtpPayload) =>
  apiRequest<EmailOtpResponse>(sendEmailOtpRequest(payload));

export const verifyEmailOtp = (payload: VerifyEmailOtpPayload) =>
  apiRequest<EmailOtpResponse>(verifyEmailOtpRequest(payload));

export const useSendEmailOtp = (
  options?: UseMutationOptions<EmailOtpResponse, ApiError, SendEmailOtpPayload>
) => useApiMutation(sendEmailOtpRequest, options);

export const useVerifyEmailOtp = (
  options?: UseMutationOptions<
    EmailOtpResponse,
    ApiError,
    VerifyEmailOtpPayload
  >
) => useApiMutation(verifyEmailOtpRequest, options);
